"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Home = void 0;
var storybook_1 = require("@eyecons/storybook");
var ra_fetch_1 = require("ra-fetch");
var react_1 = __importDefault(require("react"));
function Home(_a) {
    var className = _a.className;
    var livestreams = ra_fetch_1.useApi('backend').index('public.videos', {
        type: 'live',
        paginate: 12,
        tags: true,
        options: true,
        resource: 'VideoFull',
    })[0];
    if (livestreams.loading) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return react_1.default.createElement("div", { className: storybook_1.Helpers.classNames('storybook-pages-home', className) },
        react_1.default.createElement("div", { className: 'storybook-pages-home-bg-dark' },
            Boolean(livestreams.data.length) && react_1.default.createElement(storybook_1.Home.HeroLive, { livestreams: livestreams }),
            !Boolean(livestreams.data.length) && react_1.default.createElement(storybook_1.Home.Hero, null)),
        react_1.default.createElement("div", { className: 'storybook-pages-home-bg-grey' },
            react_1.default.createElement("div", { className: 'storybook-pages-home-sports' },
                react_1.default.createElement(storybook_1.Home.Sports, null),
                react_1.default.createElement(storybook_1.Home.Competitions, null))),
        react_1.default.createElement("div", { className: 'storybook-pages-home-bg-white' },
            react_1.default.createElement(storybook_1.Home.Channels, null)));
}
exports.Home = Home;
Home.propTypes = {};
Home.defaultProps = {};
